import { Button } from '@vzmi/shp_shared_compo'
import _ from 'lodash'
import styles from './index.css'
import { ATTRIBUTE_DISPLAY_MODE_SELECTED } from '../../../../../constants/batchProposals'

const ApplyModeTip = props => {
  const { batchApplyMode, toggleBatchApplyMode, onBatchAppply, listing, index } = props
  const attrModeSelectedStatus = _.get(listing, ATTRIBUTE_DISPLAY_MODE_SELECTED, false)
  const attributes = _.get(listing, 'attributes', [])
  const attributesSelectedStatus = !!_.find(attributes, item => item.selectedValues_selected)
  const isChecked = attrModeSelectedStatus || attributesSelectedStatus // 判斷attributeDisplayMode 及 attributes是否勾選
  return (
    <div
      className={styles.tableActions}
    >
      {
        batchApplyMode && (
          <div className={styles.tipMsg}>
            <p className={styles.tipErrorMsg}>請勾選欲套用至此次提案所有賣場之規格項目。</p>
            <p className={styles.tipNormalMsg}>若該賣場無被勾選之規格項目或選項，將不會被套用</p>
          </div>
        )
      }
      {
        batchApplyMode && (
          <>
            <Button
              data-role='batch-apply-confirm-btn'
              className={styles.batchApplyConfirmBtn}
              onClick={() => onBatchAppply(batchApplyMode, listing, index)}
              size='medium'
              disabled={!isChecked}
              fluid
            >
              確認批次套用
            </Button>
            <Button
              data-role='batch-apply-cancel-btn'
              className={styles.batchApplyModelCancelBtn}
              onClick={() => toggleBatchApplyMode(batchApplyMode, listing, index)}
              buttonType='outline'
              size='medium'
              fluid
            >
              取消批次套用
            </Button>
          </>
        )
      }
    </div>
  )
}

export default ApplyModeTip
